export function isCanvasEnabledServer(): boolean {
  return process.env.CANVAS_ENABLED === 'true';
}

function projectBucket(projectId: string): number {
  let hash = 2166136261;
  for (let index = 0; index < projectId.length; index += 1) {
    hash ^= projectId.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) % 100;
}

export function isCanvasEnabledForProject(projectId: string): boolean {
  if (!isCanvasEnabledServer() || !projectId || projectId.startsWith('unscoped_')) return false;
  const allowlist = new Set(
    String(process.env.CANVAS_ALLOWED_PROJECT_IDS || '')
      .split(',')
      .map(value => value.trim())
      .filter(Boolean)
  );
  if (allowlist.has(projectId) || allowlist.has('*')) return true;
  const rollout = Math.min(100, Math.max(0, Number(process.env.CANVAS_ROLLOUT_PERCENT || 100)));
  return projectBucket(projectId) < rollout;
}

export function isCanvasEnabledClient(): boolean {
  return process.env.NEXT_PUBLIC_CANVAS_ENABLED === 'true';
}
